import { set } from "lodash";

const construct = (obj) => {
  if (!obj) return {};

  return Object.keys(obj).reduce((acc, path) => {
    set(acc, path, obj[path]);
    return acc;
  }, {});
};

export const mapOutgoingValues = (values) => {
  return construct(values);
};
